'use client'

import NewsTagBarSkeleton from '@fe-news/components/molecules/NewsTagBar/NewsTagBarSkeleton';
import dynamic from "next/dynamic";
import { Suspense } from 'react';

const NewsTagBar = dynamic(() => import('@fe-news/components/molecules/NewsTagBar/NewsTagBar'), {
  loading: () => <NewsTagBarSkeleton />,
  ssr: false,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DynamicLoadNewsTagBar = (props: any) => {
  return (
    <Suspense>
      <NewsTagBar {...props} />
    </Suspense>
  );
}

export default DynamicLoadNewsTagBar;
